var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurityDisable = function SvgSecurityDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    fill: "#FFE2E2",
    rx: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 4,
    y: 4,
    stroke: "#FFF3F3",
    strokeWidth: 8,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    fillRule: "evenodd",
    d: "M28 21a2 2 0 0 0-2 2v1h4v-1a2 2 0 0 0-2-2Zm-4 2v1h-1a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1v-1a4 4 0 0 0-8 0Zm-1 11v-8h10v8H23Zm6-5a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z",
    clipRule: "evenodd"
  })));
};
export default SvgSecurityDisable;